import React, { useEffect, useState } from "react";
import { Grid, Typography, Avatar, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/Auth";
import DefaultImageProfile from "./profile-default.png";
import UserInputField from "./Fields/UserInputField";
import UserPhoneNumber from "./Fields/UserPhoneNumber";
import { separarNombreYApellidos } from "../../utils/icon/separarNombreApellido";
import {
  createUserProfile,
  getUserLoginLogsByUserId,
  getUserProfile,
} from "../../controllers/operaciones";
import { Spinner } from "../Loading/Spinner";
import MuiAlert from "@mui/material/Alert";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TableLogs from "../Table/TableLogs";
import CountrySelect from "./Fields/CountrySelect";

export default function UserProfile() {
  const { user, setUser } = useAuthContext();

  const [toastOpen, setToastOpen] = useState(false);
  const navigate = useNavigate();
  const [image, setImage] = useState(DefaultImageProfile);
  const [logsLimit] = useState(15);
  const [userData, setUserData] = useState({
    name: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    cargo: "",
    RBD: "",
    colegio: "",
    pais: "",
    ciudad: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [loginLogs, setLoginLogs] = useState([]);

  useEffect(() => {
    (async () => {
      if (user) {
        setIsLoading(true);
        await handleLoadProfile();
        await handleLoadLoginLogs();
        setIsLoading(false);
      }
    })();
  }, [user]);

  useEffect(() => {
    console.log("useEffect userdata", userData);
  }, [userData]);

  //Detecta el cambio en el Alert para despues de 3 seg cerrarlo
  useEffect(() => {
    if (toastOpen) {
      setTimeout(() => {
        setToastOpen(false);
      }, 3000);
    }
  }, [toastOpen]);

  const handleInputChange = (field) => (event) => {
    setUserData((prevData) => ({
      ...prevData,
      [field]: event.target ? event.target.value : event,
    }));
  };

  //Detecta cambios en el componente country en el input city
  const handleInputChangeCity = (city) => {
    setUserData((prevData) => ({
      ...prevData,
      ciudad: city,
    }));
  };

  //Detecta cambios en el componente country
  const handleInputChangePais = (pais) => {
    console.log("pais", pais);
    setUserData((prevData) => ({
      ...prevData,
      pais: pais,
    }));
  };

  //Guarda los cambios y envia el request para propagar cambios en la BD
  const handleGuardar = async () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setIsLoading(true);
    console.log("handleGuardar", { userData });
    const respuesta = await createUserProfile(user.id, userData);
    setUser((prev) => ({
      ...prev,
      name: respuesta.nombre + " " + respuesta.apellido,
    }));
    setIsLoading(false);
    setToastOpen(true);
  };

  const handleCancelar = () => {
    navigate(-1);
  };

  //Carga la información de perfil del usuario
  const handleLoadProfile = async () => {
    const profile = await getUserProfile(user.id);
    if (profile) {
      const { nombre, apellido, tel, cargo, RBD, colegio, pais, ciudad } =
        profile;
      const { email } = user;
      setUserData({
        name: nombre,
        lastname: apellido,
        email,
        phoneNumber: tel,
        cargo,
        RBD,
        colegio,
        pais,
        ciudad,
      });
    } else {
      const result = separarNombreYApellidos(user.name);
      setUserData({
        name: result.nombre || "",
        lastname: result.apellidos || "",
        email: user.email || "",
        phoneNumber: "",
        cargo: "",
        RBD: "",
        colegio: "",
        pais: "",
        ciudad: "",
      });
    }
    setImage(user.picture || DefaultImageProfile);
  };

  //Carga los logs de inicio de sesión del usuario
  const handleLoadLoginLogs = async () => {
    const logs = await getUserLoginLogsByUserId(user.id, logsLimit);
    console.log({ logs });
    setLoginLogs(logs);
  };

  return (
    <>
      {toastOpen && (
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setToastOpen(false)}
          severity="success"
        >
          ¡Sus datos fueron actualizados correctamente!
        </MuiAlert>
      )}
      {isLoading && <Spinner />}
      {!isLoading && (
        <>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              mb={5}
            >
              <Avatar sx={{ width: 120, height: 120 }}>
                <img src={image} width={120} alt="Profile" />
              </Avatar>
              <Typography fontWeight={"bold"} fontSize={"30px"}>
                {user.name}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              xl={4}
              sx={{ borderRight: 1, borderColor: "divider", p: 2 }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontSize: "20px",
                  fontFamily: "Inter",
                }}
              >
                Datos Personales
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} xl={6}>
                  <UserInputField
                    label="Nombre"
                    value={userData.name}
                    onChange={handleInputChange("name")}
                  />
                </Grid>
                <Grid item xs={12} xl={6}>
                  <UserInputField
                    label="Apellido"
                    value={userData.lastname}
                    onChange={handleInputChange("lastname")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <UserInputField
                    label="Email"
                    value={userData.email}
                    onChange={handleInputChange("email")}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <UserPhoneNumber
                    label={"Número de celular"}
                    value={userData.phoneNumber}
                    onChange={handleInputChange("phoneNumber")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <UserInputField
                    label="Cargo"
                    value={userData.cargo}
                    onChange={handleInputChange("cargo")}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              xl={4}
              sx={{ borderRight: 1, borderColor: "divider", p: 2 }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontSize: "20px",
                  fontFamily: "Inter",
                }}
              >
                Datos del Colegio
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} xl={3}>
                  <UserInputField
                    label="RBD de la Escuela"
                    value={userData.RBD}
                    onChange={handleInputChange("RBD")}
                  />
                </Grid>
                <Grid item xs={12} xl={9}>
                  <UserInputField
                    label="Nombre de la Escuela"
                    value={userData.colegio}
                    onChange={handleInputChange("colegio")}
                  />
                </Grid>
                <Grid item xs={12} xl={9}>
                  <CountrySelect
                    label="País"
                    country={userData.pais}
                    city={userData.ciudad}
                    onPaisChange={handleInputChangePais}
                    onCityChange={handleInputChangeCity}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              xl={4}
              sx={{ borderRight: 1, borderColor: "divider", p: 2 }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontSize: "20px",
                  fontFamily: "Inter",
                }}
              >
                Mis Accesos
              </Typography>
              <TableLogs data={loginLogs} limit={logsLimit} />
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Stack spacing={2} direction="row">
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleCancelar}
                  startIcon={<ArrowBackIcon />}
                >
                  Volver
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleGuardar}
                  endIcon={<SaveIcon />}
                >
                  Guardar
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
